/**
 * @fileoverview Sales Dashboard query hook.
 * @description Wraps GET /sales/dashboard in a TanStack query. The call takes no input; the token
 * decides the scope. It sits under the Sales CRM key, so every sales command's refresh also reloads
 * it, and a failed load is shown as an error with a retry, never as zero figures.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getSalesDashboard } from '@/features/sales/services/sales-dashboard.service'

/**
 * @description Fetches the Sales Dashboard.
 * @returns {ReturnType<typeof useQuery>} The query (data is the dashboard).
 */
export function useSalesDashboard() {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.salesDashboard,
    queryFn: getSalesDashboard,
  })
}
